import { useHistory } from 'react-router-dom';
import { formatDateBR, isValidDate } from '../../../../../../../utilities/date';

interface Props {
  id: string;
  produtor: string;
  nAmostra: string;
  especie: string;
  dataEntrada: Date | null;
  status: string;
  amostra1: string;
  amostra2: string;
  media: string;
}

export default function ListaCanteiroAreiaItem({
  id, produtor, nAmostra, especie, dataEntrada, status, amostra1, amostra2, media,
}: Props) {
  const history = useHistory();
  const isDataEntradaValida = isValidDate(dataEntrada);

  let statusClass = '';
  if (status.toLowerCase() === 'iniciado') {
    statusClass = 'iniciado';
  } else if (status.toLowerCase() === 'realizado') {
    statusClass = 'realizado';
  } else if (status.toLowerCase() === 'pendente') {
    statusClass = 'pendente';
  }

  const handleClick = () => {
    history.push(`/sementes/canteiro-areia/${id}`);
  };

  return (
    <div
      className="card card-clickable"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleClick();
        }
      }}
    >
      <div>{produtor}</div>
      <div><strong>{nAmostra}</strong></div>
      <div>{especie}</div>
      <div>{isDataEntradaValida ? formatDateBR(dataEntrada) : ''}</div>
      <div>
        <span className={`status ${statusClass}`}>{status}</span>
      </div>
      <div>{amostra1}</div>
      <div>{amostra2}</div>
      <div>{media}</div>
      <div className="chevron">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path
            d="M9 18L15 12L9 6"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  );
}
